import {TicketSvc}  from '../services/ticket.service';
import {GatewaySvc} from '../services/gateway.service';
import {EventBus}   from '../utilities/event.bus';
import { TranslationSvc } from '../services/translation.service';

function showMessage(message, data, delay = 1500, type = 'warning') {
    const msg = TranslationSvc.getTranslation(message, data);
    GatewaySvc.getGatewaySvc().showDialog({
        message: msg,
        delay: delay,
        type: type
    });
}

 class Rule  {

    /** @constructor */

        constructor(){
        }


    /**
     * Prebetslip validation
     * @returns {boolean}
     */

    validatePreBetslip() {

        let ticket = TicketSvc.getTicketSvc().ticket;
        let isValid = true;

        //max number of bets
        if (ticket && ticket.bets.length === sevenConfig.data.config.rules.maxBetNumber.value) {
            isValid = false;

            showMessage('max_bet_number', parseFloat(sevenConfig.data.config.rules.maxBetNumber.value).toFixed(2));
        }

        return isValid;
    }

    /**
     * Validate betslip ticket
     * @param ticket
     * @returns {boolean}
     */
    validateBetslip(ticket) {

        let isValid = true;
        const minBetAmount = sevenConfig.data.config.rules.minBetAmount.value;
        const maxBetAmount = sevenConfig.data.config.rules.maxBetAmount.value;
        const minBetAmountPerComb = sevenConfig.data.config.rules.minCombBetAmount.value;

        if (!ticket.bets.length) {
            EventBus.$emit('Payin.Failed');
            return;
        }

        ticket.bets.forEach(bet => {

            isValid = true;

            if (bet.stake < minBetAmount * bet.numEvents) {
                isValid = false;
                showMessage('min_amount_per_bet', parseFloat(minBetAmount).toFixed(2));
            } else if (bet.stake > maxBetAmount * bet.numEvents) {
                isValid = false;
                showMessage('max_amount_per_bet', parseFloat(maxBetAmount).toFixed(2));
            } else if (bet.system && bet.stake / bet.combinations < minBetAmountPerComb * bet.numEvents) {
                isValid = false;
                showMessage('min_amount_per_combination', parseFloat(minBetAmountPerComb).toFixed(2));
            }

            return isValid;
        });

        return isValid;
    }
}

export default Rule;




// WEBPACK FOOTER //
// rules.js